export default "__VITE_ASSET__Btl9KV59__"